var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgHexaFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1103.36 1270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1089.33,311.97c5.53,3.21,10.04,11.07,10.03,17.46l-1.12,611.19c-.01,6.39-4.55,14.23-10.08,17.43l-529.3,305.59c-5.54,3.2-14.56,3.14-20.06-.12l-150.51-89.26c-5.5-3.26-14.52-8.54-20.06-11.74L14.06,958.05c-5.54-3.2-10.06-11.04-10.06-17.43V329.43c0-6.39,4.53-14.23,10.06-17.43L543.38,6.39c5.53-3.2,14.58-3.18,20.11,.03l525.84,305.56Z",
    style: {
      fill: "none",
      isolation: "isolate",
      opacity: 0.5,
      stroke: "#fff",
      strokeWidth: 8
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHexaFrame);
export default __webpack_public_path__ + "static/media/bg-hexa-frame.bfd2e11ebf58d5db08d97e198c795d02.svg";
export { ForwardRef as ReactComponent };